// Copyright (c) Move Closer 2022.

import { logger } from '../../../../support'

import { InPostParcel } from './InPostModal.contracts'

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
async function load (params: Record<string, string>): Promise<InPostParcel[]> {
  const baseUrl = new URL('https://api-pl-points.easypack24.net/v1/points')
  baseUrl.searchParams.append('limit', '100')
  baseUrl.searchParams.append('source', 'geov4_pl')
  baseUrl.searchParams.append('status', ['Operating', 'NonOperating'].join(','))
  baseUrl.searchParams.append('type', ['parcel_locker_only'].join(','))

  for (const [k, p] of Object.entries(params)) {
    baseUrl.searchParams.append(k, p)
  }

  try {
    const parcels = await fetch(baseUrl.toString()).then(res => res.json()).then(res => res.items)
    return Array.isArray(parcels) ? parcels : []
  } catch (e) {
    logger(e, 'error')
    return []
  }
}

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export async function loadParcels (lat: unknown, lng: unknown, dist: number): Promise<InPostParcel[]> {
  // center point of poland
  // @52.0693234,19.4781225
  if (
    typeof lat !== 'number' ||
    typeof lng !== 'number' ||
    !isFinite(lng) ||
    !isFinite(lat)
  ) {
    lat = 52.0693234
    lng = 19.4781225
  }

  return await load({
    max_distance: dist.toString(),
    relative_point: [lat, lng].join(',')
  })
}

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export async function loadParcelsByName (name: string): Promise<InPostParcel[]> {
  return await load({ name })
}
